module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";

	fox.registerWidget('Consent', {
		configure: function () {
			this.registerOptions('', {
				consentsGetMethod: 'consent.get',
				consentSaveMethod: 'consent.provideBulk',
				analyticCookies: ['_ga', '_gat', '_gid', '_gat_tracker0', 'r/collect', '_hjIncludedInSample', '_fbp'],
				functionalCookies: ['io', 'mc_lang', 'MailSubscriptionHidden', 'intercom-lou-sz14a447', 'intercom-session-sz14a447',
									'RNLBSERVERID', 'landingDesign', 'form_contactFormcontacts', 'form_contentpingInfluencerPopup', 'form_contentcontactDirectlyPopup',
									'PromoOfferHidden', 'usernameReportUnderstanding'],
			});

			fox.Consent || Object.defineProperty(fox, 'Consent', {
				get: function() {return this._wom.getRoot().rwom1('.Consent');}.bind(this)
			});

			this.callParent('configure', arguments);
		},

		_getCookieSettings: function () {
			return JSON.parse(unescape(fox.cookie.get('ConsentSettings'))) || false;
		},

		getSettings: function () {
			return this._getCookieSettings() || fox.getEnv('cookiesConsents');
		},

		getDigitSettings: function () {
			var params = this.getSettings();
			
			fox.each(params, function(value, item) {
				params[item] = Number(value);
			}.bind(this));

			return params;
		},

		getApiSettings: function () {
			var api = this.getApi('getSettingsApi', {method: 'consent.get'});
			if (api === undefined) return;
			api.psend().then(function (data) {
				if (this.apiData || !data || data.params.answer === undefined || !data.params.answer.status) {
					return;
				}
				this.apiData = data.params.answer.response;
				this.dispatchEvent('getConsentData', this.apiData);
			}.bind(this));
		},

		_getApiData: function() {
			if(!this.apiData || this.apiData === undefined) {
				this.getApiSettings();
				return this.wait('@this', 'getConsentData', {prefix: fox.uniqid('check_')})
				.then(function (data) {
					return data.params;
				}.bind(this));
			} else {
				return fox.Promise.resolve(this.apiData);
			}
		},

		setSetting: function (name, status) {
			var cookieSettings = this._getCookieSettings();
			
			cookieSettings = cookieSettings || {};
			cookieSettings[name] = status;
			fox.cookie.set('ConsentSettings', JSON.stringify(cookieSettings), 3600 * 24 * 365 * 1000);

			fox.setEnv('consents.' + name, status);

			this.dispatchEvent('consentUpdated', {
				name: name,
				status: status
			});
		},

		setSettings: function (settings) {
			fox.each(settings, function(value, name) {
				this.setSetting(name, value);
			}, this);

			if (fox.site.member) {
				var api = this.getApi('setSettingsApi', {method: this.getOption('consentSaveMethod')});
				var params = this.getDigitSettings();	
				api.psend({consents: params});

				return;
			}
		},
		
		check: function (consents) {
			if (fox.site.member) {
				if (this.apiData) {
					var data = Boolean(this.apiData[consents]);
					if (!data) {this.removeCookies(consents);}
					return fox.Promise.resolve(data);
				} else {
					return fox.Promise.resolve(this._getApiData().then(function(apiData) {
						var data = Boolean(apiData[consents]);
						if (!data) {this.removeCookies(consents);}
						return apiData ? data : false;
					}.bind(this)));
				}
			} else {
				var settings = this.getSettings();
				var data = settings ? !!this.getSettings()[consents] : false;
				if (!data) {this.removeCookies(consents);}
				return fox.Promise.resolve(settings ? data : false);
			}
		},

		setCookie: function(consent, cookie) {
			this.check(consent).then(function(data) {
				if (data) {
					var name = cookie[0],
						value = cookie[1],
						lifetime = cookie[2] ? cookie[2] : 0;

					fox.cookie.set(name, value, lifetime);
				}
			});
		},

		removeCookies: function (consent) {
			// console.log('removeCookies', consent, this.getOption(consent));

			if (this.getOption(consent) !== undefined) {
				fox.each(this.getOption(consent), function(cookieName) {
					document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
					document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=' + '.' + location.hostname;
				}.bind(this));
			}
		},
		
	}, 'Controller');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/consent/widget/consent.js
// module id = 611
// module chunks = 2